// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMENT_DELETED = "Odpove\u010f bola zmazan\u00e1";
